import { render } from "./AntPlayer.vue?vue&type=template&id=558319a1"
import script from "./AntPlayer.vue?vue&type=script&lang=js"
export * from "./AntPlayer.vue?vue&type=script&lang=js"

import "./AntPlayer.vue?vue&type=style&index=0&id=558319a1&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/widgets/components_core/AntPlayer.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "558319a1"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('558319a1', __exports__)) {
    api.reload('558319a1', __exports__)
  }
  
  module.hot.accept("./AntPlayer.vue?vue&type=template&id=558319a1", () => {
    api.rerender('558319a1', render)
  })

}


export default __exports__